import { MButtonProps } from '../MButton/MButton.types';
import { ABodyProps } from '../../atoms/ABody/ABody.types';
import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import { AAccentLineProps } from '../../atoms/AAccentLine/AAccentLine.types';

export enum MHighlightTextAlignment {
  Centered = 'Centered',
  Left = 'Left',
}

export type MHighlightTextProps = {
  alignment?: MHighlightTextAlignment;
  aAccentLine?: AAccentLineProps;
  aSubheader: ASubheaderProps;
  aBody?: ABodyProps;
  showCTA?: boolean;
  mButton?: MButtonProps;
  hasAccentLine?: boolean;
};
